// extracted by mini-css-extract-plugin
export default {"refineContainer":"CustomToggleRefinement_refineContainer__uRBhD","span":"CustomToggleRefinement_span__QFKW0","selected":"CustomToggleRefinement_selected__Xz1+I"};